import React from 'react';
import styled from "styled-components"
import { motion, AnimatePresence } from "framer-motion"
import AnchorLink from 'react-anchor-link-smooth-scroll'

const SiteMenu = styled(motion.div)`
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    overflow: hidden;
    background: #fff;
    z-index: 900;
    padding: 0 0 0 24px;

    .menu{
        display: flex;
        align-items: center;
        min-height: 100vh;
        overflow: auto;
        float: left;

        &-right{
            width: 100%;
            height: 100vh;
            background: #5538FF;
            padding: 0;
            align-items: flex-start;
            display: flex;
            align-items: center;
        }

        ul{
          margin: 0;
          padding: 0;
          list-style: none;
    
          li{
            a{
              padding: 12px 0;
              color: #ffffff;
              font-size: 22px;
              line-height: 1;
              font-weight: 500;
              transition: all 0.2s ease;
              text-decoration: none;
              display: block;
    
              &:hover,
              &:focus{
                background: rgba(0, 0, 0, 0.08);
              }
            }

            & + li{
              margin-top: 24px;
            }
          }
        }
    }

    @media screen and (max-width: 768px) {
        padding: 0;
        overflow-y: auto;

        .menu{
            float: unset;
            flex-direction: column;
            min-height: auto;
            justify-content: flex-start;

            &-right{
                max-width: 100%;
                padding: 112px 24px 24px;
                align-items: flex-start;
                min-height: 100%;
            }
        }
    }
`;

const OverlayNav = ({toggleMenu, scrolled, setToggleMenu}) => {

    return (
      <>
        <AnimatePresence>
          {toggleMenu && (
            <SiteMenu
              data-activescroll={scrolled}
              initial={{ opacity: 0 }}
              exit={{ opacity: 0, transition: { delay: 0.1 } }}
              animate={{ opacity: toggleMenu ? 1 : 0 }}
              transition={{ duration: 0.5, ease: [0.6, 0.05, -0.01, 0.9] }}
            >
              <motion.div
                className="menu menu-right"
                initial={{ opacity: 0, x: "100%" }}
                exit={{ opacity: 0, x: "100%", transition: { delay: 0 } }}
                animate={{ opacity: 1, x: 0 }}
                transition={{
                  duration: 0.3,
                  ease: [0.6, 0.05, -0.01, 0.9],
                  delay: 0.1,
                }}
              >
                <ul>
                  <li>
                    <AnchorLink offset='55' href="#work" onClick={() => setToggleMenu(!toggleMenu)}>Our Work</AnchorLink>
                  </li>
                  <li>
                    <AnchorLink offset='55' href="#growth" onClick={() => setToggleMenu(!toggleMenu)}>What We Offer</AnchorLink>
                  </li>
                  <li>
                    <AnchorLink offset='55' href="#pricing" onClick={() => setToggleMenu(!toggleMenu)}>Pricing</AnchorLink>
                  </li>
                  <li>
                    <a  href="https://form.typeform.com/to/lf6sAz4T" target="_blank" rel="noreferrer">Contact Us</a>
                  </li>
                </ul>
              </motion.div>
            </SiteMenu>
          )}
        </AnimatePresence>
      </>
    )
}

export default OverlayNav